import { useState } from "react";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";

import IBoundsContext from "@app/scene/map/components/TerritoriesMode/types/IBoundsContext";

const useBoundsContextHandler = (): IBoundsContext => {
  const [canUndo, setCanUndo] = useState<boolean>(false);
  const [canRedo, setCanRedo] = useState<boolean>(false);
  const [creating, setCreating] = useState<boolean>(false);
  const [color, setColor] = useState<AnyColor | undefined>();
  const [listeners, setListeners] = useState<
    | {
        onRedo: () => void;
        onStartOver: () => void;
        onUndo: () => void;
      }
    | undefined
  >();

  return {
    canChangeState: creating,
    canRedo,
    canUndo,
    color,
    onRedo: listeners?.onRedo,
    onStartOver: listeners?.onStartOver,
    onUndo: listeners?.onUndo,
    setCanChangeState: setCreating,
    setCanRedo,
    setCanUndo,
    setColor,
    setListeners,
  };
};

export default useBoundsContextHandler;
